const pageNameKey = "serviceUsersListView";

export const serviceUsersListViewEn = {
  [pageNameKey]: {
    subtitle: "API Users List",
    addNewServiceUserButton: "Add New API User",
    errorSnackbarText: "Failed to load service users",
    errorLoadingValidUserRolesText: "Failed to load valid user roles",
    disabledAddNewUserButtonTooltip:
      "You do not have permissions to add a new service user.",
  },
};

export const serviceUsersListViewPtBr = {
  [pageNameKey]: {
    subtitle: "Lista de usuários da API",
    addNewServiceUserButton: "Adicionar novo usuário da API",
    errorSnackbarText: "Falha ao carregar usuários de serviço",
    errorLoadingValidUserRolesText:
      "Falha ao carregar funções de usuário válidas",
    disabledAddNewUserButtonTooltip:
      "Você não tem permissão para adicionar um novo usuário de serviço.",
  },
};

export const serviceUsersListViewDe = {
  [pageNameKey]: {
    subtitle: "API-Benutzer Liste",
    addNewServiceUserButton: "Neuen API-Benutzer hinzufügen",
    errorSnackbarText: "Fehler beim Laden der Dienstbenutzer",
    errorLoadingValidUserRolesText: "Fehler beim Laden der Benutzerrollen",
    disabledAddNewUserButtonTooltip:
      "Sie haben keine Berechtigung, einen neuen Dienstbenutzer hinzuzufügen.",
  },
};

export const serviceUsersListViewZhHans = {
  [pageNameKey]: {
    subtitle: "API用户列表",
    addNewServiceUserButton: "添加新API用户",
    errorSnackbarText: "加载服务用户失败",
    errorLoadingValidUserRolesText: "加载有效用户角色失败",
    disabledAddNewUserButtonTooltip: "您没有权限添加新服务用户。",
  },
};

export const serviceUsersListViewIt = {
  [pageNameKey]: {
    subtitle: "Elenco utenti API",
    addNewServiceUserButton: "Aggiungi Nuovo Utente API",
    errorSnackbarText: "Impossibile caricare gli utenti del servizio",
    errorLoadingValidUserRolesText: "Impossibile caricare ruoli utente",
    disabledAddNewUserButtonTooltip:
      "Non hai i permessi per aggiungere un nuovo utente di servizio.",
  },
};

export const serviceUsersListViewEs = {
  [pageNameKey]: {
    subtitle: "API Lista de usuarios",
    addNewServiceUserButton: "Agregar nuevo usuario API",
    errorSnackbarText: "Error al cargar los usuarios del servicio",
    errorLoadingValidUserRolesText:
      "No se pudieron cargar los roles de usuario válidos",
    disabledAddNewUserButtonTooltip:
      "No tienes permisos para agregar un nuevo usuario de servicio.",
  },
};

export const serviceUsersListViewNl = {
  [pageNameKey]: {
    addNewServiceUserButton: "Nieuwe API-gebruiker toevoegen",
    disabledAddNewUserButtonTooltip:
      "U hebt geen toestemming om een nieuwe servicegebruiker toe te voegen.",
    errorLoadingValidUserRolesText:
      "Fout bij het laden van de gebruikersrollen",
    errorSnackbarText: "Fout bij het laden van de servicegebruikers",
    subtitle: "Lijst met API-gebruikers",
  },
};

export const serviceUsersListViewTr = {
  [pageNameKey]: {
    addNewServiceUserButton: "Yeni API Kullanıcısı Ekle",
    disabledAddNewUserButtonTooltip:
      "Yeni bir hizmet kullanıcısı ekleme izniniz yok.",
    errorLoadingValidUserRolesText: "Geçerli kullanıcı rolleri yüklenemedi",
    errorSnackbarText: "Hizmet kullanıcıları yüklenemedi",
    subtitle: "API Kullanıcı Listesi",
  },
};
